import { DownloadIcon, PDFIcon } from "../../assets/icons";
import { Button } from "../../components/button/button";
import styles from "./policy.module.css";
import { openExternalLink } from "../../utils/openExternalLink";
import { useEffect, useState } from "react";
import { PageLoader } from "../../components/loader/pageLoader";
import LegalAPI from "../../api/LegalAPI";

const openLegalDocument = (documentType) => {
    const baseUrl = process.env.REACT_APP_API_URL
        ? process.env.REACT_APP_API_URL.replace(/\/$/, "")
        : "/api/v1";

    openExternalLink(`${baseUrl}/legal/${documentType}`);
}

const Document = ({ documentType, documentName }) => {
    return (
        <Button
            text={
                <div className={styles.text}>
                    <PDFIcon className={styles.pdf_icon} />
                    <span>
                        {documentName}
                    </span>
                </div>
            }
            type="secondary"
            icon={<DownloadIcon />}
            onClick={() => openLegalDocument(documentType)}
        />
    );
}

export const Policy = () => {
    const [loading, setLoading] = useState(true);
    const [documents, setDocuments] = useState([]);

    useEffect(() => {
        LegalAPI
            .fetchLegalDocumentsList()
            .then(setDocuments)
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <PageLoader />;
    }

    return (
        <div className={styles.files}>
            {
                documents.map(doc =>
                    <Document
                        key={doc.type}
                        documentType={doc.type}
                        documentName={doc.name}
                    />
                )
            }
        </div>
    )
}